var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 7.5H10.8333V5.83333H9.16667M10 16.6667C6.325 16.6667 3.33333 13.675 3.33333 10C3.33333 6.325 6.325 3.33333 10 3.33333C13.675 3.33333 16.6667 6.325 16.6667 10C16.6667 13.675 13.675 16.6667 10 16.6667ZM10 1.66667C8.90565 1.66667 7.82202 1.88221 6.81097 2.301C5.79992 2.71979 4.88127 3.33362 4.10744 4.10744C2.54464 5.67025 1.66667 7.78986 1.66667 10C1.66667 12.2101 2.54464 14.3298 4.10744 15.8926C4.88127 16.6664 5.79992 17.2802 6.81097 17.699C7.82202 18.1178 8.90565 18.3333 10 18.3333C12.2101 18.3333 14.3298 17.4554 15.8926 15.8926C17.4554 14.3298 18.3333 12.2101 18.3333 10C18.3333 8.90565 18.1178 7.82202 17.699 6.81097C17.2802 5.79992 16.6664 4.88127 15.8926 4.10744C15.1187 3.33362 14.2001 2.71979 13.189 2.301C12.178 1.88221 11.0943 1.66667 10 1.66667ZM9.16667 14.1667H10.8333V9.16667H9.16667V14.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.1ed09408336a6f688d97a8f8b490483f.svg";
export { ForwardRef as ReactComponent };